import {
    ReactElement,
    ButtonHTMLAttributes
} from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    myStyle?: string;
    text: string;
    icon?: any;
    children?:ReactElement;
}

export function Title({ myStyle, text, icon , children}: Props): ReactElement {

    return (
        <div className="custom-title">
           <div>
           {icon && <img src={icon} alt="هامرز" className="custom-title-icon"/>}
            <span className="custom-title-text">
                {text}
            </span>
           </div>


            {children}
        </div>
    )
}

export default Title;